import axiosInstance from "api/axiosInstance";

export type LogEntry = {
  id: string;
  timestamp: string;
  level: string;
  message: string;
  context?: Record<string, string>;
  exception?: string;
  source?: string;
  subSource?: string;
  isActive: boolean;
  retryCount: number;
  maxRetries: number;
};

const mapLogDto = (dto: any): LogEntry => ({
  id: dto.id || dto._id,            
  timestamp: dto.timestamp,
  level: dto.level,
  message: dto.message,
  context: dto.context,
  exception: dto.exception,
  source: dto.source,
  subSource: dto.subSource,
  isActive: dto.isActive,
  retryCount: dto.retryCount,
  maxRetries: dto.maxRetries,
});

export const logRepository = {
  // GET ALL LOGS
  getLogs: async (): Promise<LogEntry[]> => {
    const { data } = await axiosInstance.get("/api/logs");
    return data.map(mapLogDto);
  },

    // FETCH PAGINATED LOGS
  getPaginatedLogs: async (
    pageNumber: number,
    pageSize: number
  ): Promise<LogEntry[]> => {
    const { data } = await axiosInstance.get("/api/logs", {
      params: { pageNumber, pageSize },
    });

    return data.map(mapLogDto);
  },

  // GET BY LEVEL
  getLogsByLevel: async (level: string): Promise<LogEntry[]> => {
    const { data } = await axiosInstance.get(`/api/logs/level/${level}`);
    return data.map(mapLogDto);
  },

  // GET BY ID
  getLogById: async (id: string): Promise<LogEntry> => {
    const { data } = await axiosInstance.get(`/api/logs/${id}`);
    return mapLogDto(data);
  },


};
